/* gk-sizechart */
if (!customElements.get('gk-sizechart')) {
  class GkSizechart extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[data-gk-sc-drawer]');
      this.openBtn = this.querySelector('[data-gk-sc-open]');
      this.closeBtns = this.querySelectorAll('[data-gk-sc-close]');
      this.tabs = Array.from(this.querySelectorAll('[data-gk-sc-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-gk-sc-panel]'));

      if (this.openBtn) this.openBtn.addEventListener('click', () => this.open());
      this.closeBtns.forEach((el) => el.addEventListener('click', () => this.close()));
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.switchTab(tab.dataset.gkScTab)));

      this.escHandler = (e) => { if (e.key === 'Escape') this.close(); };

      // Textos do guia de medidas em "tu" (o texto vem fixo do tema)
      this.fixGuideText();

      // "Tabela de medidas" ao lado do título "Tamanho" (volta a pôr-se sozinho se o seletor de tamanhos for redesenhado)
      this.placeInline();
      const scope = this.closest('.product__info-container') || this.parentElement;
      if (scope && window.MutationObserver && !this.observer) {
        this.observer = new MutationObserver(() => this.placeInline());
        this.observer.observe(scope, { childList: true, subtree: true });
      }
    }

    fixGuideText() {
      const map = [
        [/Como tirar suas medidas:?/i, 'Como tirar as tuas medidas:'],
        [/^Posicione a fita métrica na costura superior do ombro.*$/i, 'Coloca a fita métrica na costura de cima do ombro, onde a manga se junta ao corpo, e estica-a até à bainha da camisola.'],
        [/^Meça a distância de uma axila à outra.*$/i, 'Mede a distância de uma axila à outra, na parte da frente da camisola.'],
        [/^Posicione a fita métrica no pé.*$/i, 'Mede com a fita métrica desde os pés até ao topo da cabeça.'],
      ];
      const root = this.drawer || this;
      root.querySelectorAll('.gk-sc__guide-title, .gk-sc__step-desc').forEach((el) => {
        const t = el.textContent.trim();
        for (const [re, txt] of map) {
          if (re.test(t)) { el.textContent = txt; break; }
        }
      });
      const guide = root.querySelector('.gk-sc__guide');
      if (guide) guide.setAttribute('aria-label', 'Como tirar as tuas medidas');
    }

    findSizeLegend() {
      const scope = this.closest('.product__info-container') || this.parentElement;
      if (!scope) return null;
      const legends = Array.from(scope.querySelectorAll('variant-selects legend.form__label'));
      if (!legends.length) return null;
      return legends.find((l) => /tamanho|size|taille|talla/i.test(l.textContent)) || legends[0];
    }

    placeInline() {
      if (!this.openBtn) return;
      const legend = this.findSizeLegend();
      if (!legend) {
        // sem seletor de tamanhos: a linha original continua no sítio
        if (!this.contains(this.openBtn)) this.prepend(this.openBtn);
        this.classList.remove('gk-sc--inline');
        return;
      }
      if (legend.contains(this.openBtn)) return;
      legend.classList.add('gk-sc-legend');
      legend.appendChild(this.openBtn);
      this.classList.add('gk-sc--inline');
    }

    open() {
      if (!this.drawer) return;
      // Move o drawer pro body pra evitar z-index issues
      if (this.drawer.parentNode !== document.body) {
        document.body.appendChild(this.drawer);
      }
      this.drawer.removeAttribute('hidden');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.drawer.classList.add('is-open'));
      });
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.escHandler);
    }

    close() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      setTimeout(() => {
        this.drawer.setAttribute('hidden', '');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.escHandler);
      }, 320);
    }

    switchTab(id) {
      this.tabs.forEach((t) => {
        const active = t.dataset.gkScTab === id;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panels.forEach((p) => {
        const active = p.dataset.gkScPanel === id;
        p.classList.toggle('is-active', active);
        if (active) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
    }
  }
  customElements.define('gk-sizechart', GkSizechart);
}
